import React from 'react'

const approvalUrl = 'https://api.citrus.ge/docs/approval.pdf'

const NewsletterPreferencesSection = ({ preferences, loading, onToggle }) => {
  return (
    <div className="rounded-2xl border border-slate-200 shadow-sm p-4 sm:p-6 pb-8 mb-8">
      <div className="mb-5">
        <h2 className="text-[19px] font-semibold text-slate-800 mb-2">
          შეტყობინებების პარამეტრები
        </h2>
        <p className="text-sm text-slate-500">
          აირჩიეთ რა არხებით გსურთ მიიღოთ მარკეტინგული შეთავაზებები.
        </p>
      </div>

      <div className="grid gap-4">
        <label className="flex items-center justify-between gap-4 rounded-xl border border-slate-200 p-4 cursor-pointer">
          <div>
            <div className="text-[15px] font-medium text-slate-800">ელ.ფოსტა</div>
            <div className="text-sm text-slate-500">
              შეთავაზებების მიღება ელ.ფოსტით{' '}
              <a
                href={approvalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-citrus-red underline"
                onClick={e => e.stopPropagation()}
              >
                გაიგე მეტი
              </a>
            </div>
          </div>
          <input
            type="checkbox"
            className="w-4 h-4 accent-citrus-red"
            checked={preferences.subscribed_email}
            disabled={loading}
            onChange={e => onToggle('subscribed_email', e.target.checked)}
          />
        </label>

        <label className="flex items-center justify-between gap-4 rounded-xl border border-slate-200 p-4 cursor-pointer">
          <div>
            <div className="text-[15px] font-medium text-slate-800">SMS</div>
            <div className="text-sm text-slate-500">
              შეთავაზებების მიღება SMS-ით{' '}
              <a
                href={approvalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-citrus-red underline"
                onClick={e => e.stopPropagation()}
              >
                გაიგე მეტი
              </a>
            </div>
          </div>
          <input
            type="checkbox"
            className="w-4 h-4 accent-citrus-red"
            checked={preferences.subscribed_sms}
            disabled={loading}
            onChange={e => onToggle('subscribed_sms', e.target.checked)}
          />
        </label>
      </div>
    </div>
  )
}

export default NewsletterPreferencesSection
